import { Navigate, Route, Routes } from 'react-router-dom';
import React, { lazy } from 'react';

import { useUser } from '../../hooks/useUser';
import { AppRoute, BuildingScreenTab, hasPermission } from '../../utils/navigation';
import SoknadLayout from '../soknad/soknadLayout';
import SoknadScreen from '../soknad';
import NewSoknadRegistration from '../soknad/newSoknadRegistration';

import DocumentsForEnovaApplicationWrapper from './tabs/enovaApplication';

const BuildingScreenLayout = lazy(() => import('./buildingPageLayout'));
const ExpertToolsScreen = lazy(() => import('../expertTools'));
const TiltakTab = lazy(() => import('./pages/energisparendeTiltak'));
const EnergyAssessment = lazy(() => import('./pages/energivurdering'));
const EnergyRating = lazy(() => import('./pages/energimerking'));
const About = lazy(() => import('./pages/omBoligen'));
const Energiattest = lazy(() => import('./pages/energiattest'));
const Energiplan = lazy(() => import('./pages/energiplan'));

export const BuildingRoutes = () => {
  const { user } = useUser();
  return (
    <Routes>
      <Route path=":buildingId">
        <Route element={<BuildingScreenLayout />}>
          <Route
            index
            element={
              // Redirect to default tab
              <Navigate to={BuildingScreenTab.ENERGY_CERTIFICATE} replace />
            }
          />
          <Route path={BuildingScreenTab.ENERGY_CERTIFICATE} element={<Energiattest />} />
          <Route path={BuildingScreenTab.ABOUT} element={<About />} />
          <Route path={BuildingScreenTab.ENERGY_RATING} element={<EnergyRating />} />
          <Route path={BuildingScreenTab.DOCUMENTS} element={<DocumentsForEnovaApplicationWrapper />} />
          <Route path={BuildingScreenTab.ENERGY_ASSESSMENT} element={<EnergyAssessment />} />
          <Route path={BuildingScreenTab.ENERGY_SAVING_MEASURES} element={<TiltakTab />} />
          <Route path={BuildingScreenTab.ENERGIPLAN} element={<Energiplan />} />
        </Route>

        {hasPermission(AppRoute.EXPERT_TOOLS_VARME, user) && (
          <Route path="ekspert-varme/:area" element={<ExpertToolsScreen />} />
        )}

        {hasPermission(AppRoute.EXPERT_TOOLS_KULDE, user) && (
          <Route path="ekspert-kulde/:area" element={<ExpertToolsScreen />} />
        )}

        <Route element={<SoknadLayout />}>
          <Route path="ny-soknad" element={<NewSoknadRegistration />} />
          <Route path="soknad">
            <Route path=":soknadId">
              <Route path=":soknadSteg">
                <Route path=":step?">
                  <Route path=":tab?" element={<SoknadScreen />} />
                </Route>
              </Route>
            </Route>
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};
